<div class="espaco__equipamentos" *ngIf="apareceOuNao">
  <p>EQUIPAMENTO: {{ equipamento }}</p>
</div>
<div>
  <div class="section__table">
    <table class="table" >
      <thead>
        <tr>
          <ng-container class="cabecalho__tabela">
            <th class="item__tabela" *ngFor="let header of cabecalhosTabela">{{ header }}</th>
          </ng-container>
        </tr>
      </thead>
      <tbody class="scrollable-content">
        <tr class="item">
          <ng-container class="cabecalho__tabela" >
            <td class="item__tabela" *ngFor="let infos of informacoesTabela">{{ infos }}</td>
          </ng-container>
        </tr>
      </tbody>
      <ng-content ></ng-content>
    </table>
  </div>
</div>
